import React from "react";
import { Box, CircularProgress, Typography, useTheme } from "@mui/material";

const CircularProgressWithLabel = ({
  value,
  color,
  size = 80,
  thickness = 4,
  label,
}) => {
  const theme = useTheme();

  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress
        variant="determinate"
        value={value}
        size={size}
        thickness={thickness}
        sx={{ color: color }}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Typography
          variant="body2"
          component="div"
          sx={{ fontWeight: "bold", color: theme.palette.text.primary }}
        >
          {`${value}%`}
        </Typography>
        {label && (
          <Typography
            variant="caption"
            component="div"
            sx={{ color: theme.palette.text.secondary, fontSize: "0.6rem" }}
          >
            {label}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default CircularProgressWithLabel;
